import React from 'react';
import { ThemeProvider } from '@chegg-ui/theme';
import { useNavigationData, NavigationDataType } from '@chegg-me-components/navigation-data';
import LegalLinks from '../components/LegalLinks';
import { FooterLegalContext, FooterLegalTheme } from '../shared';
import { FootNoteContainer, FooterLegalContainer } from '../styles/index';

var FooterLegal = function FooterLegal(_ref) {
  var _ref$legalLinks = _ref.legalLinks,
      legalLinks = _ref$legalLinks === void 0 ? [] : _ref$legalLinks,
      legalNote = _ref.legalNote,
      envUrl = _ref.envUrl,
      dataTestPrefix = _ref.dataTestPrefix,
      clientEnv = _ref.clientEnv,
      locale = _ref.locale,
      useCache = _ref.useCache,
      isPreviewMode = _ref.isPreviewMode,
      accessToken = _ref.accessToken,
      countryCode = _ref.countryCode,
      oneGraphClient = _ref.oneGraphClient;
  var context = {
    envUrl: envUrl,
    dataTestPrefix: dataTestPrefix
  };
  var skipQuery = legalLinks && legalLinks.length > 0;

  var _useNavigationData = useNavigationData({
    skipQuery: skipQuery,
    navigationDataType: NavigationDataType.FooterLegal,
    clientEnv: clientEnv,
    locale: locale,
    useCache: useCache,
    isPreviewMode: isPreviewMode,
    accessToken: accessToken,
    countryCode: countryCode,
    oneGraphClient: oneGraphClient
  }),
      _useNavigationData$da = _useNavigationData.data;

  _useNavigationData$da = _useNavigationData$da === void 0 ? {} : _useNavigationData$da;
  var _useNavigationData$da2 = _useNavigationData$da.LegalNav,
      LegalNav = _useNavigationData$da2 === void 0 ? legalLinks : _useNavigationData$da2,
      _useNavigationData$da3 = _useNavigationData$da.FooterLegalNote,
      FooterLegalNote = _useNavigationData$da3 === void 0 ? legalNote : _useNavigationData$da3;
  var parsedLegalLinks = LegalNav.map(function (item) {
    return item.parent || item;
  });
  var legalTextNote = FooterLegalNote === null || FooterLegalNote === void 0 ? void 0 : FooterLegalNote.text;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: FooterLegalTheme
  }, /*#__PURE__*/React.createElement(FooterLegalContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(FooterLegalContainer, null, /*#__PURE__*/React.createElement(FootNoteContainer, {
    "data-test": "".concat(dataTestPrefix, "-foot-note"),
    variant: "caption",
    variantType: "normal"
  }, legalTextNote || "\xA9 2003-".concat(new Date().getFullYear(), " Chegg Inc. All rights reserved.")), /*#__PURE__*/React.createElement(LegalLinks, {
    legalLinks: parsedLegalLinks
  }))));
};

FooterLegal.displayName = 'FooterLegal';
export default FooterLegal;